<template>
  <b-card
    v-if="data"
    no-body
    class="card-revenue-budget"
  >
    <b-row class="mx-0">
      <b-col
        md="8"
        class="revenue-report-wrapper"
      >
        <div class="d-sm-flex justify-content-between align-items-center mb-3">
          <h4 class="card-title mb-50 mb-sm-0">
           Rapport de revenus
          </h4>
          <div class="d-flex align-items-center">
            <div class="d-flex align-items-center mr-2">
              <span class="bullet bullet-info svg-font-small-3 mr-50 cursor-pointer" />
              <span>Dépense</span>
            </div>
            <div class="d-flex align-items-center ml-75">
              <span class="bullet bullet-primary svg-font-small-3 mr-50 cursor-pointer" />
              <span>Revenus</span>
            </div>
          </div>
        </div>

        <!-- chart -->
        <vue-apex-charts
          id="revenue-report-chart"
          type="bar"
          height="230"
          :options="revenueReport.chartOptions"
          :series="dashboardData.revenueReport.series"
        />
      </b-col>

      <b-col
        md="4"
        class="budget-wrapper mt-75"
      >
        <b-dropdown
          :text="currentYear"
          size="sm"
          class="budget-dropdown mt-75"
          variant="outline-primary"
        >
          <b-dropdown-item
            v-for="year in dashboardData.years"
            :key="year"
          >
            {{ year }}
          </b-dropdown-item>
        </b-dropdown>
              <!-- <h3 class="mb-25 mt-75">
      Dépense   : {{ dashboardData.expense }}
        </h3>
        <h3 class="mb-25 mt-75">
    Revenus  : {{ dashboardData.earning }}
        </h3>
    -->
        <h2 class="mb-25 mt-75">
          Gain : {{ dashboardData.price }}
        </h2>
        <vue-apex-charts
        class="mt-75"
          id="budget-chart"
          type="line"
          height="80"
          :options="budgetChart.options"
          :series="dashboardData.budgetChart.series"
        />

      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    VueApexCharts,
    BDropdown,
    BDropdownItem,
    BCard,
    BButton,
    BRow,
    BCol,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  created(){    
    this.dashboardData= this.data;
    },
  data() {
    return {
      dashboardData:{},
      revenue_report: {},
      revenueReport: {
        chartOptions: {
          chart: {
            stacked: true,
            type: 'bar',
            toolbar: { show: false },
          },
          grid: {
            padding: {
              top: -20,
              bottom: -10,
            },
            yaxis: {
              lines: { show: false },
            },
          },
          xaxis: {
            categories: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
            labels: {
              style: {
                colors: '#6E6B7B',
                fontSize: '0.86rem',
                fontFamily: 'Montserrat',
              },
            },
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          colors: [$themeColors.primary, $themeColors.info],
          plotOptions: {
            bar: {
              columnWidth: '17%',
              endingShape: 'rounded',
            },
            distributed: true,
          },
          yaxis: {
            labels: {
              style: {
                colors: '#6E6B7B',
                fontSize: '0.86rem',
                fontFamily: 'Montserrat',
              },
            },
          },
        },
      },
      // budget chart
      budgetChart: {
        options: {
          chart: {
            height: 80,
            toolbar: { show: false },
            zoom: { enabled: false },
            type: 'line',
            sparkline: { enabled: true },
          },
          stroke: {
            curve: 'smooth',
            dashArray: [0, 5],
            width: [2],
          },
          colors: [$themeColors.primary, '#dcdae3'],
          tooltip: {
            enabled: false,
          },
        },
      },
      currentYear: (new Date().getFullYear()).toString()
    }
  },
}
</script>
